var styleDataHash = "197b6463";
const injectCss = (() => {
  var css = `.eiV4x{background-color:var(--ricos-settings-dividers-color,#ededed);height:var(--ricos-settings-dividers-height,36px);margin-block:-3px;width:1px}.m7P3R{height:42px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var toolbar_button_separator_default = {
  "separator": "eiV4x",
  "mobileSeparator": "m7P3R"
};
export {
  toolbar_button_separator_default as default,
  injectCss
};
//# sourceMappingURL=toolbar-button-separator-scss.js.map
